import { useContext } from "react";
import { Link } from "react-router-dom";
import MobileMenu from "./MobileMenu";
import { mobileMenuContext } from "../contexts/MobileMenuProvider";

const Footer = () => {
  const { openMenu } = useContext(mobileMenuContext);
  return (
    <>
      <div className="footer py-4 d-flex flex-lg-column " id="kt_footer">
        {/*begin::Container*/}
        <div className=" container-xxl  d-flex flex-column flex-md-row align-items-center justify-content-between">
          {/*begin::Copyright*/}
          <div className="text-gray-900 order-2 order-md-1">
            <span className="text-muted fw-semibold me-1">
              {new Date().getFullYear()}&copy;
            </span>
            <Link to="/" className="text-gray-800 text-hover-primary">
              {process.env.REACT_APP_BRAND_NAME || ""}
            </Link>
          </div>
          {/*end::Copyright*/}

          {/*begin::Menu*/}
          <ul className="menu menu-gray-600 menu-hover-primary fw-semibold order-1">
            <li className="menu-item">
              <Link to="/" className="menu-link px-2">
                Disclaimer
              </Link>
            </li>

            <li className="menu-item">
              <Link to="/" className="menu-link px-2">
                Privacy Policy
              </Link>
            </li>

            <li className="menu-item">
              <Link to="/" className="menu-link px-2">
                Terms and Conditions
              </Link>
            </li>
          </ul>
          {/*end::Menu*/}
        </div>
        {/*end::Container*/}
      </div>
      {openMenu && <MobileMenu />}
    </>
  );
};

export default Footer;
